@if (
	!isLoadingAvailableConfidentialUsers &&
	!isLoadingAvailableTemplates &&
	!isOpeningRequest &&
	newRequest.id === '' &&
	isUploadingCustomfields.length === 0
) {
	<div class="request-opening-container">
		<div
			class="informative-box"
			[innerHTML]="EncodingMSP.decodeHTML(requestTemplate.informative)"
			*ngIf="requestTemplate.informative && requestTemplate.informative !== ''"></div>

		<div class="mb-2">
			<cpi-input-with-autocomplete
				[availableOptions]="!forceOpenRequestWithCi ? availableTemplateIAC : []"
				[setValue]="requestTemplateId"
				[setInputText]="requestTemplate.summary"
				[minInputLength]="0"
				[placeholder]="labels['lbl_chamado_selecione_template']"
				[disabled]="initOnTemplate"
				(getInputText)="newRequest.summary = $event"
				(onValueChange)="$event !== '' ? setTemplate($event) : resetRequest(true)">
			</cpi-input-with-autocomplete>
		</div>

		<div class="label">{{ labels.lbl_chamado_solicitacao }}:</div>
		<input [value]="newRequest.summary" (input)="newRequest.summary = $event.target.value" [disabled]="hasTemplate" />

		<div class="dotted-input-container">
			<span>{{ labels.lbl_geral_chamado_confidencial }}</span>
			<cpi-checkbox
				[value]="this.newRequest.confidential === '1' ? true : false"
				(oValue)="changeConfidentialRequest($event)"
				[innerText]="this.newRequest.confidential === '1' ? labels.lbl_geral_sim : labels.lbl_geral_nao"
				[disabledByTemplate]="hasTemplate === true">
			</cpi-checkbox>
		</div>
		<div class="mb-2" *ngIf="this.newRequest.confidential === '1'">
			<ng-container>
				<cpi-input-with-autocomplete
					(onValueChange)="addConfidentialUser($event)"
					[setValue]="availableConfidentialUsersIAC.values[0]"
					[availableOptions]="availableConfidentialUsersIAC"
					[placeholder]="labels.lbl_buscar_usuarios + ' (' + labels.lbl_iac_min_char_search.replace('$__$', '2') + ')'"
					[minInputLength]="2"
					[inputHeight]="'30px'">
				</cpi-input-with-autocomplete>

				<div class="confidential-users-container">
					<cpi-generic-form-gen
						*ngIf="!isLoadingAvailableConfidentialAnalysts"
						(tappedField)="restoreUsersToAvailableList()"
						[setGenericForm]="[customConfidentialFormRMK]"
						[labels]="labels">
					</cpi-generic-form-gen>
				</div>
			</ng-container>
		</div>

		<div [ngClass]="{ 'form-wrap': logFileArray.length > 0 }">
			<div class="dotted-input-container">
				<span>
					<span>{{ labels.lbl_anexo_abertura }}</span>
					<span [title]="allowedMimeTypeTip"><fa-icon [icon]="icons.faQuestionCircle"></fa-icon></span>
				</span>
				<div class="label">
					<input
						type="file"
						id="requestOpeningFileEl"
						#requestOpeningFileEl
						(change)="handleFileLog()"
						[multiple]="true"
						[accept]="allowedMimeTypeStr" />
					<label class="button" for="requestOpeningFileEl">{{ labels.lbl_geral_anexar_arquivo }}</label>
				</div>
			</div>

			<div class="label" *ngIf="logFileArray.length > 0">{{ labels.lbl_geral_anexo }}</div>
			<div class="file-container">
				<div class="dotted-input-container" *ngFor="let file of logFileArray; let index = index">
					<span>{{ file.name }}.{{ file.extension }}</span>
					<span (click)="handleFileLog(index)">
						<fa-icon [icon]="icons.faTrash"></fa-icon>
					</span>
				</div>
			</div>
		</div>

		@if (!options || !options.hide || !options.hide.includes('enduser')) {
			<div class="collapse-container">
				<div
					class="header"
					[ngClass]="{ collapsed: collapseContainer.enduser }"
					(click)="collapseContainer.enduser = !collapseContainer.enduser">
					<span>{{ labels.lbl_asset_info_usuario }}</span>
					<span><fa-icon [icon]="collapseContainer.enduser ? icons.faAngleDown : icons.faAngleUp"></fa-icon></span>
				</div>
				@if (!collapseContainer.enduser) {
					<div class="body">
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_nome }}</span> <input disabled [value]="enduserData.fullName" />
						</div>
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_email }}</span> <input disabled [value]="enduserData.email" />
						</div>
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_login }}</span> <input disabled [value]="enduserData.login" />
						</div>
						<div class="dotted-input-container">
							<span>{{ labels.lbl_chave_unica }}</span> <input disabled [value]="enduserData.uniquekey" />
						</div>
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_tel_celular }}</span> <input disabled [value]="enduserData.phone" />
						</div>
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_depto }}</span> <input disabled [value]="enduserData.department" />
						</div>
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_observacoes }}</span> <input disabled [value]="enduserData.notes" />
						</div>
						<div class="dotted-input-container">
							<span>{{ labels.lbl_geral_localidade }}</span>
							<input disabled [value]="enduserData.site + ' - ' + enduserData.location" />
						</div>
						@if (isEnduserView) {
							<div class="dotted-input-container">
								<span>{{ labels.lbl_localidade_afetada }}</span>
								<input disabled [value]="enduserData.site + ' - ' + enduserData.location" />
							</div>
						}
						@if (isAnalystView) {
							<div class="dotted-input-container">
								<span>{{ labels.lbl_localidade_afetada }}*</span>
								<select [(ngModel)]="newRequest.affected_location">
									<option value="" disabled>{{ labels.lbl_geral_selecione }}</option>
									@for (affectedLocation of affectedLocations; track affectedLocation) {
										<option [value]="affectedLocation.value">
											{{ affectedLocation.label }}
										</option>
									}
								</select>
							</div>
						}
					</div>
				}
			</div>
		}

		<div class="classification-container" *ngIf="!hasTemplate || forceOpenRequestWithCi">
			<div class="header">
				<span>{{ labels.lbl_geral_classificacao }}</span>
			</div>
			<div class="body">
				<div class="tip" *ngIf="forceOpenRequestWithCi">
					{{ labels.lbl_limitacao_classificacoes_relacionadas }} {{ newRequest.relatedCis[0]?.identification }}
				</div>

				<pcp-request-classification-reverse-rmk
					[alertField]="classificationOptions.alertField"
					[lockField]="classificationOptions.lockField"
					[idCustomerList]="options.id_customer"
					[idTargetCi]="classificationOptions.idCmdb ? classificationOptions.idCmdb : null"
					(getClassification)="setClassification($event)"
					(isClassificationFulfilled)="isClassificationFulfilled = $event"
					[hideServiceType]="options.hide_service_type">
				</pcp-request-classification-reverse-rmk>

				@if (this.newRequest.service_type?.toString() === SERVICE_TYPES_ENUM.PROBLEM) {
					<div class="dotted-input-container">
						<span>
							<span>{{ labels.lbl_geral_tipo_de_risco }}*</span>
						</span>
						<div>
							<select (change)="newRequest.riskType = $event.target.value">
								>
								<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
								<option [value]="'0'">Normal</option>
								<option [value]="'1'">Fast</option>
								<option [value]="'2'">Emergencial</option>
							</select>
						</div>
					</div>
				}
			</div>
		</div>

		<div class="collapse-container" *ngIf="customfields && customfields.length > 0">
			<div class="header">{{ labels.lbl_geral_campos_customizados }}</div>
			<div class="body">
				<pcp-request-customfield
					[idTopic]="newRequest.id_topic"
					[idCategory]="newRequest.id_category"
					[idSolutionArea]="newRequest.id_solution_area"
					[verifyFields]="verifyFields"
					(isCustomfieldFulfilled)="isCustomfieldFulfilled = $event"
					(isCustomfieldLoading)="isCustomfieldLoading = $event"
					(customfields)="customfields = $event">
				</pcp-request-customfield>
			</div>
		</div>

		@if (
			relatedCisOptions?.length === 0 &&
			((newRequest.id_topic && newRequest.id_category && newRequest.id_solution_area && newRequest.allowedCiTypes?.length > 0) ||
				forceOpenRequestWithCi)
		) {
			<div class="collapse-container">
				<div class="header">{{ labels.lbl_vincular_ci_chamado }} {{ newRequest.mandatoryCiBinding === true ? '*' : '' }}</div>
				<div class="body">
					<pcp-cmdb-search-gadget [allowedCiTypeList]="newRequest.allowedCiTypes.join(',')" (getCi)="setSelectedCi($event)">
					</pcp-cmdb-search-gadget>

					<div class="ci-container">
						@for (ci of newRequest.relatedCis; let index = $index; track ci) {
							<div class="dotted-input-container">
								<span>{{ ci.identification }}</span>
								<span (click)="unbondCi(index)">
									<fa-icon [icon]="ci.id !== classificationOptions.idCmdb ? icons.faTrash : icons.faLock"></fa-icon>
								</span>
							</div>
						}
					</div>
				</div>
			</div>
		} @else if (relatedCisOptions?.length > 0) {
			<div class="collapse-container">
				<div
					class="header"
					[ngClass]="{ collapsed: collapseContainer.bondCi }"
					(click)="collapseContainer.bondCi = !collapseContainer.bondCi">
					<span>{{ labels.lbl_vincular_ci_chamado }}</span>
					<span><fa-icon [icon]="collapseContainer.bondCi ? icons.faAngleDown : icons.faAngleUp"></fa-icon></span>
				</div>
				@if (!collapseContainer.bondCi) {
					<div class="body">
						<div class="select-bond-ci-container">
							<!-- @for (relatedCi of relatedCisOptions; track $index) {
								<div>
									<input type="checkbox" />
									<span> {{ relatedCi.id }} - {{ relatedCi.type }} {{ relatedCi.identification }} </span>
								</div>
							} -->
							<msp-table-rmk
								[containerStyle]="{ 'max-height': '20rem', overflow: 'auto' }"
								[headers]="relatedCisOptionsTable"
								[data]="relatedCisOptionsData()"
								[enableSorting]="true"
								[sort]="relatedCisOptionsSort"
								(getSort)="relatedCisOptionsSort = $event"
								[enableSearching]="true"
								(getSearch)="relatedCisOptionsSearch[$event.id] = $event.values"
								[enableSelecting]="true"
								(getSelectedRow)="newRequest.relatedCis = $event">
							</msp-table-rmk>
						</div>
					</div>
				}
			</div>
		}

		<div
			class="form-wrap header"
			[ngClass]="{ alert: isAlertRelatedInciedent }"
			*ngIf="relatedIncident.length > 0"
			(click)="isRelatedIncidentScreenOpen = !isRelatedIncidentScreenOpen">
			<div>
				{{
					selectedRelatedIncident == undefined
						? this.labels.lbl_chamados_classificacoes_semelhantes_vincular
						: selectedRelatedIncident.id + ' - ' + selectedRelatedIncident.summary
				}}
			</div>
			<div><fa-icon [icon]="icons.faAngleRight"></fa-icon></div>
		</div>

		<cpi-dot-bounce-loading-effect class="mt-2" *ngIf="isLoadingRequestTemplate"></cpi-dot-bounce-loading-effect>

		<div>
			<div class="label">
				{{ labels.lbl_geral_descricao }}<span class="label" *ngIf="requestTemplate.description_required">*</span>
			</div>
			<textarea
				[ngStyle]="{ 'min-height': '48px', 'overflow-y': 'auto', resize: 'vertical' }"
				[value]="newRequest.description"
				(input)="newRequest.description = $event.target.value"
				#descriptionTextarea></textarea>
		</div>

		<button
			class="submit button"
			[ngClass]="{
				disabled:
					(isAnalystView && !isClassificationFulfilled) ||
					(hasTemplate && requestTemplate.summary && requestTemplate.summary.trim() === '') ||
					!newRequest.summary ||
					(newRequest.summary && newRequest.summary.trim() === '') ||
					(newRequest.id_enduser && newRequest.id_enduser === '0') ||
					isCustomfieldLoading ||
					isLoadingRequestTemplate ||
					(newRequest.mandatoryCiBinding == true && newRequest.relatedCis?.length == 0) ||
					(customfields?.length > 0 && !isCustomfieldFulfilled),
			}"
			(click)="submitRequest()">
			{{ labels.lbl_chamado_abrir }}
		</button>
	</div>
}

<div class="request-end-container" *ngIf="newRequest.id !== '' && isUploadingCustomfields.length == 0">
	<a [routerLink]="'/request/' + newRequest.id" class="title"
		>{{ labels.lbl_request_successful_open }}, ID: {{ newRequest.id }}.
		<span class="link">{{ labels.lbl_clique_aqui_para_chamado }}!</span></a
	>

	<div class="button-container center">
		<button class="button" (click)="cloneRequest()">{{ labels.lbl_abrir_chamado_novamente }}</button>
		<button class="button" (click)="openModalEvaluationMSP()">{{ labels.lbl_geral_avaliar }} MySupport</button>
	</div>
</div>

<div class="related-request-container" *ngIf="isRelatedIncidentScreenOpen">
	<div class="tip">{{ labels.lbl_encontrados_chamados_mesma_classificacao_cis_relacionados }}</div>
	<div
		class="request-card"
		[ngClass]="{ selected: selectedRelatedIncident == request }"
		(click)="selectedRelatedIncident = request; newRequest.parent_request.id = request.id; isRelatedIncidentScreenOpen = false"
		*ngFor="let request of relatedIncident">
		<div>
			<span>ID:</span>
			<span>{{ request.id }}</span>
		</div>
		<div>
			<span>{{ labels.lbl_chamado_solicitacao }}:</span>
			<span>{{ request.summary }}</span>
		</div>
		<div>
			<span>{{ labels.lbl_geral_descricao }}:</span>
			<span>{{ request.description }}</span>
		</div>
		<div>
			<span>{{ labels.lbl_chamado_data_abertura }}:</span>
			<span>{{ request.open_date }}</span>
		</div>
	</div>
	<button
		class="button"
		(click)="selectedRelatedIncident = undefined; newRequest.parent_request.id = undefined; isRelatedIncidentScreenOpen = false">
		{{ labels.lbl_estes_chamados_nao_estao_relacionados }}
	</button>
</div>

<div
	class="evaluation-msp-modal evaluation-msp-modal-extremity-close"
	id="modalClose"
	(click)="modalClose($event, false)"
	*ngIf="isOpenModalEvaluationMSP">
	<div class="evaluation-msp-modal-content">
		<span class="evaluation-msp-modal-close" (click)="modalClose($event, true)"><fa-icon [icon]="icons.faXmark"></fa-icon></span>
		<app-mysupport-evaluation></app-mysupport-evaluation>
	</div>
</div>

<div
	class="loading-container"
	*ngIf="isLoadingAvailableConfidentialUsers || isLoadingAvailableTemplates || isOpeningRequest || isUploadingCustomfields.length > 0">
	<cpi-svg-gears></cpi-svg-gears>
	<div>{{ isUploadingCustomfields.length == 0 ? labels.lbl_edocs_carregando : labels.lbl_estamos_quase_la }}!</div>
</div>
